// @mui
import { Card, CardContent } from '@mui/material';
// components
import { GoogleBannerAds } from "./GoogleAds";

export default function CardAds() {
  return (
    <Card>
      <CardContent>
        <GoogleBannerAds />
      </CardContent>
    </Card>
  );
}
